import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=669a15a4"
import script from "@/views/Products/Products.ts?vue&type=script&lang=ts&external"
export * from "@/views/Products/Products.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports